import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input, FormGroup, Label, Form, Row, Col, Card, CardBody, InputGroup, InputGroupText } from "reactstrap";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { getCookie } from "../../Helpers/Utils";

const AddAdminExpense = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = getCookie("user_data") ? JSON.parse(getCookie("user_data")) : {};

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '45px',
            borderRadius: '8px',
            borderColor: state.isFocused ? '#2e4a3d' : '#dee2e6',
            boxShadow: state.isFocused ? '0 0 0 0.1rem rgba(46, 74, 61, 0.25)' : 'none',
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 })
    };

    // Backend allowed_types kooda sync panniyachu
    const typeOptions = [
        { value: "expense", label: "Expense" },
        { value: "investment", label: "Investment" }
    ];

    const [formData, setFormData] = useState({
        type: "purchase",
        amount: "",
        description: "",
        date: new Date().toISOString().split('T')[0], // Backend expects Y-m-d
        staff_id: ""
    });

    const [staffOptions, setStaffOptions] = useState([]);
    const [availableBalance, setAvailableBalance] = useState(0);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (user.role === 'admin') {
            const getStaffs = async () => {
                try {
                    const res = await Handler({ method: "GET", url: "/staff/list.php" });
                    if (res?.success) {
                        setStaffOptions(res.data.map(s => ({ value: s.id, label: s.name?.toUpperCase() })));
                    }
                } catch (err) { toast.error("Error loading staff list"); }
            };
            getStaffs();
        } else {
            setFormData(prev => ({ ...prev, staff_id: user.id }));
        }
    }, []);

    // Fetch balance logic (Optional: Backend-la balance check irundha use pannikalam)
    useEffect(() => {
        if (formData.staff_id) {
            const fetchBalance = async () => {
                try {
                    const res = await Handler({
                        method: "GET",
                        url: `/deposit/balance.php?staff_id=${formData.staff_id}`
                    });
                    if (res?.success) setAvailableBalance(res.data.summary.balance);
                } catch (err) { console.error("Balance fetch error"); }
            };
            fetchBalance();
        }
    }, [formData.staff_id]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: "" });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        dispatch(loadingTrue());

        try {
            const res = await Handler({
                method: "POST",
                url: "/expense/admin_create.php", // Unga backend path-ku yetha mari mathikonga
                data: formData
            });

            if (res?.success) {
                Swal.fire("Success!", res.message, "success");
                navigate("/expenses");
            } else {
                // Backend errors-ah frontend state-la set pandrom
                if (res?.errors) setErrors(res.errors);
                toast.error(res?.message || "Something went wrong");
            }
        } catch (err) {
            Swal.fire("Error", "Internal Server Error", "error");
        } finally {
            dispatch(loadingFalse());
        }
    };

    return (
        <div className="p-3">
            <div className="mb-4 d-flex justify-content-between align-items-center">
                <div>
                    <h4 className="fw-bold mb-0">Add New Expense</h4>
                    <small className="text-muted">Fill the form to record a business expense</small>
                </div>
                <Button color="light" onClick={() => navigate(-1)}>Back</Button>
            </div>

            <Row>
                <Col lg={8}>
                    <Card className="border-0 shadow-sm p-2" style={{ borderRadius: '12px' }}>
                        <CardBody>
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    {/* {user?.role === 'admin' && (
                                        <Col md={12} className="mb-3">
                                            <FormGroup>
                                                <Label className="fw-bold">Staff Member</Label>
                                                <Select
                                                    options={staffOptions}
                                                    styles={customSelectStyles}
                                                    placeholder="Select staff..."
                                                    onChange={(opt) => setFormData({ ...formData, staff_id: opt ? opt.value : "" })}
                                                />
                                            </FormGroup>
                                        </Col>
                                    )} */}

                                    <Col md={6} className="mb-3">
                                        <FormGroup>
                                            <Label className="fw-bold">Date</Label>
                                            <Input
                                                type="date"
                                                name="date"
                                                value={formData.date}
                                                onChange={handleChange}
                                                style={{ height: '45px', borderRadius: '8px' }}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col md={6} className="mb-3">
                                        <FormGroup>
                                            <Label className="fw-bold">Expense Category</Label>
                                            <Select
                                                options={typeOptions}
                                                styles={customSelectStyles}
                                                defaultValue={typeOptions[0]}
                                                onChange={(opt) => setFormData({ ...formData, type: opt.value })}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col md={12} className="mb-3">
                                        <FormGroup>
                                            <Label className="fw-bold">Amount</Label>
                                            <InputGroup>
                                                <InputGroupText className="bg-light">₹</InputGroupText>
                                                <Input
                                                    type="number"
                                                    name="amount"
                                                    placeholder="0.00"
                                                    className={errors.amount ? "is-invalid" : ""}
                                                    style={{ height: '45px' }}
                                                    value={formData.amount}
                                                    onChange={handleChange}
                                                />
                                            </InputGroup>
                                        </FormGroup>
                                        {errors.amount && <div className="text-danger small">{errors.amount}</div>}
                                    </Col>

                                    <Col md={12} className="mb-3">
                                        <FormGroup>
                                            <Label className="fw-bold">Description</Label>
                                            <Input
                                                type="textarea"
                                                name="description"
                                                rows="3"
                                                placeholder="What was this expense for?"
                                                className={errors.description ? "is-invalid" : ""}
                                                value={formData.description}
                                                onChange={handleChange}
                                            />
                                            {errors.description && <div className="text-danger small">{errors.description}</div>}
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <div className="d-grid mt-2">
                                    <Button color="primary" size="lg" type="submit" style={{ borderRadius: '8px', background: '#2e4a3d', border: 'none' }}>
                                        Save Expense
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>

                <Col lg={4}>
                    <Card className="border-0 shadow-sm text-center p-3 mb-3" style={{ borderRadius: '12px', background: '#f8f9fa' }}>
                        <CardBody>
                            <div className="mb-2">
                                <i className="bx bx-info-circle text-primary fs-3"></i>
                            </div>
                            <h6 className="text-muted mb-1">Current Balance</h6>
                            <h3 className={`fw-bold ${availableBalance < 0 ? 'text-danger' : 'text-success'}`}>
                                ₹ {parseFloat(availableBalance).toLocaleString('en-IN')}
                            </h3>
                            <p className="small text-muted mb-0 mt-2">
                                Carefully record expenses to maintain accurate account history.
                            </p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default AddAdminExpense;